// ============================================================
// CODE CLOCK - the trailing `:<rounds>` a timed condition code carries.
//
// Custom modifiers (`Pen:`), stat drains (`Dn:`) and exposures (`Ex:`)
// all end in an optional round count after their LAST colon - the last,
// because a body may hold colons of its own (`afflict=Pen:dodge=-10`).
// One parser, so the three families can never disagree on it.
//
// Pure. Zero React dependency.
// ============================================================

/** A timed code's body and its clock. */
export interface CodeClock {
  /** Everything before the clock. */
  body: string;
  /** The round count; always a whole number. */
  rounds: number;
}

/**
 * Split a trailing `:<digits>` off `text`. Null when there is none - no
 * colon, a colon in first place (an empty body), or a non-numeric tail.
 */
export function splitClock(text: string): CodeClock | null {
  const lastColon = text.lastIndexOf(':');
  const tail = text.slice(lastColon + 1);
  if (lastColon <= 0 || !/^\d+$/.test(tail)) return null;
  return { body: text.slice(0, lastColon), rounds: parseInt(tail, 10) };
}
